
import React, { useState, useEffect } from "react";
import { Card, Row, Col, ButtonGroup, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ReactApexChart from "react-apexcharts";

const RoomBookingGraph = ({ platform }) => {
  const { t } = useTranslation();
  const [timeRange, setTimeRange] = useState("month");
  const [chartData, setChartData] = useState({
    series: [],
    options: {},
  });



  console.log(platform, "platform")
  // Extract data from props
  const platformStats = platform?.revanueReports || {};
  const compareData = platform?.compareData || [];
  const graphData = platform?.graphData || [];


  // Get monthly data for the current year
  const monthlyData = compareData[0]?.monthly || {};

  // Prepare chart data from API response
  const bookingData = {
    day: {
      categories: [
        "00:00", "04:00", "08:00", "12:00", "16:00", "20:00", "24:00"
      ],
      series: [
        {
          name: t("manageEarning.chart.series.revenue"),
          data: [4500, 5200, 3800, 6500, 7200, 6800, 5500],
        },
      ],
    },
    week: {
      categories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      series: [
        {
          name: t("manageEarning.chart.series.revenue"),
          data: [12500, 14200, 13800, 16500, 17200, 16800, 15500],
        },
      ],
    },
    month: {
      categories: [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ],
      series: [
        {
          name: t("manageEarning.chart.series.totalRevenue"),
          data: Object.values(monthlyData).map(month => month.totalRevenue || 0),
        },
        {
          name: t("manageEarning.chart.series.totalCommission"),
          data: Object.values(monthlyData).map(month => month.totalCommission || 0),
        }
      ],
    },
    year: {
      categories: compareData.map(year => year.year.toString()),
      series: [
        {
          name: t("manageEarning.chart.series.totalRevenue"),
          data: compareData.map(yearData =>
            Object.values(yearData.monthly).reduce((sum, month) => sum + (month.totalRevenue || 0), 0)
          ),
        },
        {
          name: t("manageEarning.chart.series.totalCommission"),
          data: compareData.map(yearData =>
            Object.values(yearData.monthly).reduce((sum, month) => sum + (month.totalCommission || 0), 0)
          ),
        }
      ],
    },
  };
 const chartOptions = {
  chart: {
    type: "bar",
    height: 350,
    toolbar: { show: false },
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: "40%",
      borderRadius: 6,
    },
  },
  dataLabels: {
    enabled: false,
  },
  colors: ["#D1D5DB", "#EC4899"], // gray + pink like screenshot
  stroke: {
    show: true,
    width: 2,
    colors: ["transparent"],
  },
  xaxis: {
    categories: graphData.map(item => item.label),
  },
  yaxis: [
    {
      title: {
        text: "Ticket Qty",
      },
    },
    {
      opposite: true,
      title: {
        text: "Revenue",
      },
      labels: {
        formatter: val => localStorage.getItem("country")==="Thailand"?"฿":"₫" + val.toLocaleString(),
      },
    },
  ],
  legend: {
    position: "top",
    horizontalAlign: "right",
  },
  grid: {
    borderColor: "#f1f1f1",
  },
  tooltip: {
    y: {
      formatter: val => val,
    },
  },
};

const chartSeries = [
  {
    name: "Ticket Qty",
    type: "column",
    data: graphData.map(item => item.ticketQty || 0),
  },
  {
    name: "Net Revenue",
    type: "column",
    data: graphData.map(item => item.netRevenue || 0),
  },
];

  useEffect(() => {
    updateChart();
  }, [timeRange, platform]);

  const updateChart = () => {
    const data = bookingData[timeRange];

    const options = {
      chart: {
        type: "line",
        height: 350,
        toolbar: {
          show: true,
          tools: {
            download: true,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
            reset: false,
          },
        },
      },
      colors: timeRange === "month" || timeRange === "year"
        ? ["#008FFB", "#00E396"]
        : ["#008FFB"],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 3,
      },
      grid: {
        borderColor: "#f1f1f1",
        strokeDashArray: 5,
      },
      xaxis: {
        categories: data.categories,
        labels: {
          style: {
            colors: "#6B7280",
            fontSize: "12px",
          },
        },
      },
      yaxis: {
        title: {
          text: t("manageEarning.chart.amountLabel"),
          style: {
            color: "#6B7280",
            fontSize: "12px",
            fontWeight: 400,
          },
        },
        labels: {
          formatter: function (val) {
            return "$" + val?.toLocaleString();
          },
          style: {
            colors: "#6B7280",
            fontSize: "12px",
          },
        },
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return "$" + val?.toLocaleString();
          },
        },
      },
      markers: {
        size: 5,
        hover: {
          size: 7,
        },
      },
      legend: {
        position: 'top',
        horizontalAlign: 'right',
      },
    };

    setChartData({
      series: data.series,
      options: options,
    });
  };

  // Calculate totals from API data
  const getTotalRevenue = () => {
    return Object.values(monthlyData).reduce((sum, month) => sum + (month.totalRevenue || 0), 0);
  };

  const getTotalCommission = () => {
    return Object.values(monthlyData).reduce((sum, month) => sum + (month.totalCommission || 0), 0);
  };

  const getTotalBookings = () => {
    return Object.values(monthlyData).reduce((sum, month) => sum + (month.totalBookings || 0), 0);
  };
  console.log(platformStats,"psssssssssss")

  return (
    <>
      <Card className="border-1 shadow-sm">
        <Card.Body>
          <Row className="text-center">
            <Col md={3}>
              <div className="border-end">
                <h6 className="text-muted mb-1">{t("manageEarning.chart.totalAmount")}</h6>
                <h4 className="fw-bold text-primary">
                  {localStorage.getItem("country")==="Thailand"?"฿":"₫"}{platformStats.totalAmountPaid?.toLocaleString() || "0"}
                </h4>
              </div>
            </Col>
            <Col md={3}>
              <div className="border-end">
              <h6 className="text-muted mb-1">Commission</h6>
              <h4 className="fw-bold text-primary">
              {localStorage.getItem("country")==="Thailand"?"฿":"₫"}{platformStats.platformCommission?.toLocaleString() || "0"}
              </h4>
              </div>
              </Col>
            <Col md={3}>
              <div className="border-end">
                <h6 className="text-muted mb-1">{t("manageEarning.chart.totalBooking","Total Bookings")}</h6>
                <h4 className="fw-bold text-success">
                  {platformStats.totalBooking?.toLocaleString() || "0"}
                </h4>
              </div>
            </Col>
            <Col md={3}>
              <div>
                <h6 className="text-muted mb-1">{t("manageEarning.chart.averageHours","Average Hours")}</h6>
                <h4 className="fw-bold text-info">
                  {platformStats.averageHours?.toLocaleString() || "0"}
                </h4>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="border-0 shadow-sm mt-3">
        <Card.Body>
          <Row className="align-items-center">
            <Col>
              <h5 className="fw-bold text-dark mb-1">{t("manageEarning.chart.revenueAnalytics")}</h5>
              <p className="text-muted mb-0">
                {timeRange === "month" || timeRange === "year"
                  ? t("manageEarning.chart.revenueAndCommissionOverview")
                  : t("manageEarning.chart.revenueTrendsOverTime")}
              </p>
            </Col>
           
          </Row>

          {/* Chart */}
          {graphData.length > 0 && (
  <ReactApexChart
  options={chartOptions}
  series={chartSeries}
  type="bar"
  height={350}
/>
)}
        </Card.Body>
      </Card>
    </>
  );
};

export default RoomBookingGraph;